import { render, staticRenderFns } from "./CertificateTemplate.html?vue&type=template&id=2bf2ffbb&scoped=true&external"
import script from "./CertificateTemplate.vue?vue&type=script&lang=js"
export * from "./CertificateTemplate.vue?vue&type=script&lang=js"
import style0 from "./CertificateTemplate.vue?vue&type=style&index=0&id=2bf2ffbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2ffbb",
  null
  
)

export default component.exports